export default [
  {
    title: "Marketplace",
    icon: "ShoppingCartIcon",
    children: [
      {
        title: "Code Source",
        icon: "CodeIcon",
        route: "marketplace",
        resource: "Invoice",
        action: "manage",
      },
    ],
  },
];
